import * as React from "react";
import styled from "@emotion/styled";
import { BaseStyleAttrs } from "@/theme";

const EMPTY_PROMPT = "選択してください";

export type SelectBoxProps = {
  selected?: string | number;
  options: Option[];
  prompt?: boolean;
} & BaseStyleAttrs &
  React.InputHTMLAttributes<HTMLSelectElement>;

const StyledSelect = styled.select<BaseStyleAttrs>`
  margin: ${({ margin = "0" }) => margin};
  padding: ${({ padding = "1px 6px" }) => padding};
  width: ${({ width = "100%" }) => width};
  height: ${({ height = "45px" }) => height};
  box-sizing: border-box;
  transition: all 0.3s;
  border: 2px solid #959595;
  border-radius: 5px;
  text-align: left;
  font-size: 14px;
  letter-spacing: 0px;
  color: #666666;
  opacity: 1;

  &:focus {
    background: #eee;
    outline: none;
  }
`;

const SelectBox = ({ options, value, prompt = true, ...props }: SelectBoxProps) => {
  return (
    <StyledSelect value={value || ""} {...props}>
      {prompt && <option value="">{EMPTY_PROMPT}</option>}
      {options.map((option, idx) => (
        <option key={`option-${idx + 1}-${option.value}`} value={option.value}>
          {option.label}
        </option>
      ))}
    </StyledSelect>
  );
};

export default SelectBox;
